import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CustomMaskedInput from 'components/MaskedInput/index';
import { theme } from 'components/Theme';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { updateRecoveryMessages, createRecoveryMessages } from 'store/Orbita/Product/actions';
import { Wysiwyg } from 'v2/components/Shared/Wysiwyg';

import type { DispatchProp } from 'react-redux';

export interface IRecoveryMessage {
  active: boolean;
  days: string;
  description: string;
  id?: number;
  sms_text: string;
  text: string;
  title: string;
}

interface IProps extends DispatchProp<any> {
  open: boolean;
  handleClose: any;
  recoveryEmail: any;
  editing: boolean;
  idProduct: any;
  callMoreData: Function;
  registeredMessages: IRecoveryMessage[];
}

interface IStates {
  submitting: boolean;
  recoveryMessage: IRecoveryMessage;
}

class RecoveryMessageForm extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      submitting: false,
      recoveryMessage: {
        active: true,
        days: '1',
        description: '',
        sms_text: '',
        text: '',
        title: '',
        id: null,
      },
    };
  }

  componentDidMount() {
    const { recoveryEmail, editing } = this.props;
    if (editing) {
      this.setState({ recoveryMessage: { ...recoveryEmail } });
    }
  }

  handleSubmit = async () => {
    const { recoveryMessage } = this.state;
    const { editing, registeredMessages } = this.props;

    let empty = 0;

    if (!recoveryMessage.description) {
      toast.error('A descrição é obrigatória');
      return;
    }

    if (recoveryMessage.days === '') {
      toast.error('Dias é obrigatório');
      return;
    }

    if (Number.parseInt(recoveryMessage.days) < 0) {
      toast.error('Dias não pode ser menor que 0');
      return;
    }

    const hasMessageForThatDay = registeredMessages.some(
      (registeredMessage: IRecoveryMessage) =>
        registeredMessage.days == recoveryMessage.days && registeredMessage.active && registeredMessage.id !== recoveryMessage.id
    );

    if (hasMessageForThatDay) {
      toast.error('Já existe uma mensagem cadastrada para esse dia');
      return;
    }

    if (recoveryMessage.sms_text && recoveryMessage.sms_text.length > 140) {
      toast.error('O texto do sms não pode ter mais que 140 caractéres');
      return;
    }

    if (!recoveryMessage.sms_text?.trim()) {
      empty += 1;
    }

    if (!recoveryMessage.text?.trim() || recoveryMessage.text === '<p></p>' || recoveryMessage.text === '<p><br></p>') {
      empty += 1;
    }

    if (empty === 2) {
      toast.error('Preencha ao menos a mensagem para e-mail ou a mensagem para sms');
      return;
    }

    if (editing) {
      this.setState({ submitting: true });
      await this.props.dispatch(updateRecoveryMessages(this.props.idProduct, recoveryMessage.id, recoveryMessage));
      this.setState({ submitting: false });
      toast.success('Mensagem alterada com sucesso!');
      this.props.callMoreData();
      this.props.handleClose();
    } else {
      this.setState({ submitting: true });
      await this.props.dispatch(createRecoveryMessages(this.props.idProduct, recoveryMessage));
      this.setState({ submitting: false });
      toast.success('Mensagem criada com sucesso!');
      this.props.callMoreData();
      this.props.handleClose();
    }
  };

  handleChange = (type: any, value: any) => {
    const { recoveryMessage } = this.state;
    recoveryMessage[type] = value;
    this.setState({ recoveryMessage });
  };

  render() {
    const { recoveryMessage } = this.state;
    return (
      <MuiThemeProvider theme={theme}>
        <Modal open={this.props.open} onClose={this.props.handleClose}>
          <Paper
            elevation={10}
            style={{
              width: '640px',
              maxWidth: '100%',
              height: 'auto',
              top: '50%',
              left: '50%',
              position: 'absolute',
              transform: 'translate(-50%,-50%)',
              padding: '1.5rem',
              maxHeight: '90vh',
              overflow: 'auto',
            }}
          >
            <Typography variant='h6' style={{ color: '#192542' }}>
              Nova mensagem
            </Typography>
            <div className='m16' />
            <div>Crie ou edite sua mensagem de recuperação de venda</div>
            <div className='m16' />
            <Grid container spacing={2}>
              <Grid item xs={12} md={2}>
                <FormControlLabel
                  label='Ativo'
                  control={
                    <Switch color='primary' checked={recoveryMessage.active} onChange={(e: any) => this.handleChange('active', e.target.checked)} />
                  }
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  label='Descrição'
                  value={recoveryMessage.description}
                  onChange={(e: any) => this.handleChange('description', e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <CustomMaskedInput
                  mask='number'
                  label='Dias'
                  disableUnderline
                  value={recoveryMessage.days}
                  onChange={(value: any) => this.handleChange('days', value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Título do E-mail'
                  value={recoveryMessage.title}
                  onChange={(e: any) => this.handleChange('title', e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <div>
                  <InputLabel style={{ paddingBottom: '0.5rem' }}>Mensagem do E-mail</InputLabel>
                  <Wysiwyg value={recoveryMessage.text || ''} onChange={(v: string) => this.handleChange('text', v)} />
                </div>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>Mensagem do sms</div>
                      <div>
                        <Chip label={`${recoveryMessage.sms_text?.length || 0}/130`} size='small' color='secondary' variant='outlined' />
                      </div>
                    </div>
                  }
                  value={recoveryMessage.sms_text}
                  onChange={(e: any) => this.handleChange('sms_text', e.target.value)}
                  inputProps={{ maxLength: 130 }}
                />
              </Grid>
              <div className='m16' />
              <Grid item xs={12}>
                <Typography variant='h6' style={{ color: '#192542' }}>
                  Nova mensagem
                </Typography>
                <div className='m16' />
                <Fragment>
                  <p>
                    <b>[[PRIMEIRONOME]]</b> - Primeiro nome do cliente
                  </p>
                  <p>
                    <b>[[NOMEDOPRODUTOR]]</b> - Nome e sobrenome do produtor
                  </p>
                  <p>
                    <b>[[NOMECONTEUDO]]</b> - Nome do conteúdo em recuperação
                  </p>
                  <p>
                    <b>[[DTFATURA]]</b> - Data de abertura da fatura / Ínicio do processo de compra
                  </p>
                  <p>
                    <b>[[DTFATVENC]]</b> - Data de vencimento da fatura
                  </p>
                  <p>
                    <b>[[FATCOD]]</b> - Código da fatura gerada na Eduzz
                  </p>
                  <p>
                    <b>[[CNTCOD]]</b> - Código do seu produto
                  </p>
                  <p>
                    <b>[[CHAVEGW]]</b> - Usado para geração do link de boleto, ex:
                    <span>https://sun.eduzz.com/thankyou/[[CNTCOD]]/[[CHAVEGW]]</span>
                  </p>
                </Fragment>
              </Grid>
              <div className='m16' />
              <Grid container justify='flex-end'>
                <Button color='default' disabled={this.state.submitting} onClick={this.props.handleClose}>
                  Fechar
                </Button>
                <Button color='primary' disabled={this.state.submitting} onClick={this.handleSubmit}>
                  Salvar
                  {this.state.submitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </Grid>
            </Grid>
            <div className='m16' />
          </Paper>
        </Modal>
      </MuiThemeProvider>
    );
  }
}

export default connect()(RecoveryMessageForm);
